export default __webpack_public_path__ + "static/media/jsp.2b7cc75d.svg";